import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'

import { PrismicLink } from 'prismic'
import Clickable from 'components/ui/Clickable'
import AspectRatio from 'components/ui/AspectRatio'
import Image from 'components/ui/Image'

import s from './ImageSlice.module.scss'

const cn = classNames.bind(s)

const ImageSliceWithLink = ({ data }) => {
  const image = data?.primary?.imageSharp?.childImageSharp ? data?.primary?.imageSharp : data?.primary?.image
  const link = data?.primary?.image_link

  if (!image) return null

  let ratio = 0.5625

  if (image.childImageSharp?.fluid?.aspectRatio) {
    ratio = image.childImageSharp?.fluid?.aspectRatio
  } else {
    // this is probably a GIF ?
    ratio = (Math.round((image.dimensions?.width / image.dimensions?.height) * 100) / 100).toFixed(2)
    ratio = parseFloat(ratio)
  }

  const altText = data?.primary?.image?.alt || ''

  const content = (
    <AspectRatio className={cn('stretch')} ratio={ratio} mediumRatio={ratio} desktopRatio={ratio}>
      <Image src={data?.primary?.imageSharp ? image : image.url} alt={altText} className={cn('image')} />
    </AspectRatio>
  )

  return (
    <div className={cn('container')}>
      <div className={cn('wrapper')}>
        {link ? (
          <Clickable to={PrismicLink.url(link)} className={cn('link')} tabIndex={0} aria-label={altText}>
            {content}
          </Clickable>
        ) : (
          content
        )}
      </div>
    </div>
  )
}

ImageSliceWithLink.propTypes = {
  data: PropTypes.object.isRequired,
  link: PropTypes.string,
}

export default ImageSliceWithLink
